export default __webpack_public_path__ + "static/media/accommdation.e2878c0c.svg";